import {
  Paragraph as Base,
  type ParagraphOptions as BaseOptions,
} from "@tiptap/extension-paragraph";
import { ReactNodeViewRenderer, NodeViewWrapper, NodeViewContent } from "@tiptap/react";

import { LineWrapperView } from "./utils/LineWrapperView";

import type { DocumentModel } from "@/models/DocumentModel";
import type { NodeViewProps } from "@tiptap/react";

type ParagraphOptions = BaseOptions & {
  renderAsChildIn: string[];
  renderPlace: string;
  doc: DocumentModel;
};

const PARAGRAPH_CONTAINER_TYPES = [
  "listItem",
  "taskItem",
  "blockquote",
  "callout",
  "tableCell",
  "tableHeader",
];

// Wrapper component for chat cases
function ParagraphChatWrapper({ extension, getPos, editor }: NodeViewProps) {
  const { renderPlace } = extension.options as ParagraphOptions;

  if (renderPlace === "chat-input") {
    return (
      <NodeViewWrapper className="mb-2.5 mt-0.5 ml-0.5">
        <NodeViewContent />
      </NodeViewWrapper>
    );
  }

  if (renderPlace === "chat-message") {
    const pos = getPos?.();
    const parentTypeName =
      typeof pos === "number" ? editor.state.doc.resolve(pos).parent.type.name : null;
    const isNested = parentTypeName != null && PARAGRAPH_CONTAINER_TYPES.includes(parentTypeName);

    return (
      <NodeViewWrapper className={isNested ? "my-0" : "my-2.5"}>
        <NodeViewContent />
      </NodeViewWrapper>
    );
  }

  return null;
}

export const Paragraph = Base.extend<ParagraphOptions>({
  addNodeView() {
    const { renderPlace } = this.options;

    if (renderPlace === "chat-input" || renderPlace === "chat-message") {
      return ReactNodeViewRenderer(ParagraphChatWrapper);
    }

    return (props) =>
      new LineWrapperView(props, {
        renderNodeAsChildIn: PARAGRAPH_CONTAINER_TYPES,
        className: "node-paragraph my-2.5",
      });
  },
});
